import React from 'react';

import style from './content.module.scss';
import { Form } from './form';
import { Info } from './info';

export const Content = () => {
    return (
        <div className={style.content}>
            <div className={style.contentTitle}>
                Please fill out the form below and we'll get back to you within 1 business day.
            </div>

            <div className={style.contentContainer}>
                <div className={style.contactItem}>
                    <Form></Form>
                </div>

                <div className={style.contactItem}>
                    <Info></Info>
                </div>
            </div>
        </div>
    );
};
